import { TextFieldProps } from '@mui/material'
import { TCytoField, TCytoStep } from '../../data/CytoData'
import { cytoDictionary } from '../../data/dd'
import NumericInput from '../../utils/NumericInput'
import { useAppDispatch, useAppSelector } from './RunReduxHooks'
import { selectCyto, setfield } from './sliceCyto'

type TCytoEntryFieldSpecificProps = { 
    field: TCytoField, 
    step: string | undefined,
    errorOnEmptyInit?: boolean
    onDictionaryFieldChange?: (field: TCytoField, newValue: number | undefined) => void 
}
type TCytoEntryFieldProps     = TCytoEntryFieldSpecificProps & TextFieldProps

type TCytoEntryFormFieldSpecificProps = { 
    field: TCytoField, 
    initialValue: number | undefined, 
    errorOnEmptyInit?: boolean
    onDictionaryFieldChange: (field: TCytoField, newValue: number | undefined) => void
}
type TCytoEntryFormFieldProps = TCytoEntryFormFieldSpecificProps & TextFieldProps



// type TCytoViewFieldSpecificProps = { field: TCytoField, step: string | undefined }
// type TCytoViewFieldProps = TCytoViewFieldSpecificProps & TextFieldProps
/*
export function CytoViewNumberField(props: TCytoViewFieldProps) {
    const field = (props as TCytoEntryFieldSpecificProps).field
    const step = props.step as TCytoStep
    const fieldValue = useAppSelector(selectCyto)[step][field]
    const fd = cytoDictionary[field]
    let displayFieldValue = fieldValue
    if (displayFieldValue !== undefined) {
        if (fd.step === 0.1) {
            displayFieldValue = (fieldValue as number).toFixed(1)
        } else if (fd.step === 0.01) {
            displayFieldValue = (fieldValue as number).toFixed(2)
        } else {
            displayFieldValue = (fieldValue as number).toFixed(0)
        }
    }

    return (
        <TextField type="number"
            disabled
            variant='standard'
            label= {fd.label}
            value={fieldValue === undefined ? '' : displayFieldValue}
            {...props}
            InputProps={
                {
                    endAdornment: <InputAdornment position="end">{fd.unit}</InputAdornment>,
                }
            }
            inputProps={{
                style: { textAlign: 'right', fontWeight: 'bold' },
                maxLength: 130,
                step: fd.step,
                min: fd.min,
                max: fd.max,
            }} />
    )
}
*/
export default function CytoNumberField(props: TCytoEntryFieldProps) {
    const field = (props as TCytoEntryFieldSpecificProps).field
    const data = useAppSelector(selectCyto)
    const fieldValue = data[props.step as TCytoStep][field] as number
    const dispatch = useAppDispatch()
    const fd = cytoDictionary[field]


    const handleChange = (newNumber: number) => {
        const newField = {
            step: props.step as TCytoStep,
            fieldName: field,
            value: newNumber
        }

        dispatch(setfield(newField))
    }
    const otherProps = {...props}
    delete otherProps.step

    
    return (
        <NumericInput
            step={fd.step}
            label={fd.label} 
            min={fd.min}
            max={fd.max}
            unit={fd.unit}
            minRecomended={fd.minRecomended}
            maxRecomended={fd.maxRecomended}
            initValue={fieldValue} 
            onNumberChanged={(newNumber:number) => handleChange(newNumber)}
            errorOnEmptyInit = {props.errorOnEmptyInit}
            {...otherProps as TextFieldProps}
            />
    )
}

export function CytoFormNumberField(props: TCytoEntryFormFieldProps) {
    const field = (props as TCytoEntryFormFieldSpecificProps).field
    const fd = cytoDictionary[field]

    const handleChange = (newNumber:number) => {
        props.onDictionaryFieldChange(field, newNumber)
    }

    return (
        <NumericInput
            step={fd.step}
            label={fd.label} 
            min={fd.min}
            max={fd.max}
            minRecomended={fd.minRecomended}
            maxRecomended={fd.maxRecomended}
            unit={fd.unit}
            initValue={props.initialValue} 
            onNumberChanged={(newNumber:number) => handleChange(newNumber)}
            errorOnEmptyInit = {props.errorOnEmptyInit}
            {...props}
            />
    )
}

